import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LessonSchedule} from 'src/app/classes/LessonSchedule';
import {Room} from 'src/app/classes/Room';
import { User } from 'src/app/classes/User';
import { BookedLessonsService } from 'src/app/services/booked-lessons.service';

@Component({
    selector: 'app-lessons-schedule-edit',
    styleUrls: ['./reschedule-booked-lesson.component.scss'],
    templateUrl: './reschedule-booked-lesson.component.html',
    encapsulation: ViewEncapsulation.None
})
export class RescheduleBookedLessonComponent implements OnInit {

    bookedLesson: any;

    currentDialog = null;
    errorMessage: string;
    loading = false;

    public bookedLessonDateTimeGroup: FormGroup;

    constructor(private activeModal: NgbActiveModal,
                private bookedLessonsService: BookedLessonsService,
                private formBuilder: FormBuilder) {
    }

    ngOnInit(): void {
      this.bookedLessonDateTimeGroup = this.formBuilder.group({
        bookingDate: [this.bookedLesson.bookingDate || null, Validators.required],
        startTime: [this.bookedLesson.startTime || null, Validators.required],
        endTime: [this.bookedLesson.endTime || null, Validators.required],
      });
    }

    closeModal(sendData: any): void {
      if (sendData instanceof FormGroup) {
        const rescheduleData = sendData.value;
        rescheduleData.startTime = rescheduleData.startTime.slice(0, 5);
        rescheduleData.lessonBookingIds = this.bookedLesson.participantsInfo.map(pI => pI.bookingId);
        this.loading = true;
        this.bookedLessonsService.reScheduleLesson(rescheduleData).subscribe(
          (_r) => {
            this.activeModal.close('success');
            this.loading = false;
          },
          (_e) => {
            this.activeModal.close('error');
            this.loading = false;
          });
        return;
      }
        this.activeModal.close(sendData.value);
    }

    validate(): boolean {
      return this.bookedLessonDateTimeGroup.valid;
    }
}
